import PammInvestorAccountPage from './PammInvestorAccountPage';

export default PammInvestorAccountPage;
